module.exports = __webpack_public_path__ + "static/GCI-ac91510cc8fdc368f308f8b67d39ca73.png";